import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Router from "next/router";
import { accountRegistration, editUserInfo, sendToDataLayer } from "api/api";
import { TitleDeliver, PrivacyPolicy } from "styles/General.styled";
import Button from "shared/Button";
import Checkbox from "shared/Checkbox";
import RequiredFields from "shared/CommonForm/RequiredFields";
import { colors } from "styles/colors";
import { Container, FormContainer, FormInner, Spinner } from "styles/App.styled";
import { BtnBlock } from "styles/FoodiePage.styled";
import { GridColumn } from "emotion-flex-grid";
import { Required } from "styles/General.styled";
import Gender from "shared/CommonForm/Gender";
import { BtnsBottom, ItemBtn } from "styles/AddRecipe.styled";
import { InputWrap, PrivasyWrapper } from "components/CreatorForm/styled";
import { useDispatch, useSelector } from "react-redux";
import { setOwner } from "store/userReducer";
import { getOwner } from "store/userReducer/userSelectors";
import { messageForm } from "store/recipesReducer/recipesActions";
import { OverlayMessage } from "components/Alert/styled";
import { SocialSignUp } from "components/SignUp";
import { fonts } from "styles/fonts";
import { useRouter } from "next/router";
import HeadTitle from "components/HeadTitle";
import { createAlert } from "../../../store/alert";

const FoodieForm = () => {
  const { register, handleSubmit, errors, watch, reset } = useForm();
  const [serverErrors, setServerErrors] = useState({});
  const [isShowDialog, setDialog] = useState(false);
  const [isBlur, setBlur] = useState(false);
  const [checked, setChecked] = useState(false);

  const [isSocialLogin, setSocialLogin] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const router = useRouter();
  const isRenderPrev = router.pathname === "/registration/foodie";

  const dispatch = useDispatch();
  const owner = useSelector(getOwner);

  useEffect(() => {
    setSocialLogin(localStorage.getItem("isSocialLogin"));
    reset({
      first_name: owner?.first_name,
      last_name: owner?.last_name,
      gender: owner?.gender,
    });
  }, [owner]);

  const isErrorExist = (err) => {
    return Object.keys(errors).includes(err);
  };

  const isServerErrorExist = (err) => {
    return Object.keys(serverErrors).includes(err);
  };

  const onSubmit = (data) => {
    if (owner.id) {
      editUserInfo(owner.id, {
        ...data,
        email: owner.email ? owner.email : data.email.toLowerCase().trim(),
        is_creator: false,
      })
        .then((res) => {
          dispatch(setOwner(res.data));
          Router.push("/");
        })
        .catch((err) => console.log(err));
    } else
      accountRegistration({ ...data, email: data.email.toLowerCase().trim() })
        .then(() => {
          dispatch(messageForm());
          setBlur(true);
          sendToDataLayer({
            registrationEvent: "registrationSuccess",
            event: "registrationSuccess",
          });
          setTimeout(() => Router.push("/"), 5000);
        })
        .catch((err) => {
          err.response && setServerErrors(err.response.data);
          setDialog(true);
        });
  };

  useEffect(() => {
    if (isShowDialog) showError();
  }, [isShowDialog]);

  const showError = () => {
    let errorMessage = Object.keys(serverErrors).length > 0 ? Object.values(serverErrors)[0] : "Something went wrong";
    dispatch(createAlert({ type: "error", message: errorMessage }));
    setDialog(false);
  };

  const toRegistrationPage = () => {
    Router.push("/registration");
  };

  return (
    <>
      <HeadTitle title={"Foody | Registration"} />
      <Container width="832px">
        <GridColumn pt={["l6", "xxl1"]} pb={["xxl13", "xxl2"]}>
          <TitleDeliver spacing>Sign Up</TitleDeliver>

          <FormContainer>
            {isLoading ? (
              <Spinner />
            ) : (
              <form onSubmit={handleSubmit(onSubmit)}>
                <FormInner>
                  {!isSocialLogin && (
                    <>
                      <BtnBlock className="w100">
                        <SocialSignUp setServerErrors={setServerErrors} setLoading={setLoading} setDialog={setDialog} />
                      </BtnBlock>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontFamily: fonts.latoRegular,
                          fontSize: "16px",
                        }}
                      >
                        <div style={{ width: "100%", height: "1px", backgroundColor: "#A3A4A6" }} />
                        <div style={{ color: "#A3A4A6", margin: "0 12px" }}>OR</div>
                        <div style={{ width: "100%", height: "1px", backgroundColor: "#A3A4A6" }} />
                      </div>
                    </>
                  )}
                  <RequiredFields
                    isErrorExist={isErrorExist}
                    isServerErrorExist={isServerErrorExist}
                    watch={watch}
                    register={register}
                    render={owner.id}
                    hasEmail={owner.email}
                  />
                  <InputWrap>
                    <div className="label">
                      Gender <Required>*</Required>
                    </div>
                    <Gender isErrorExist={isErrorExist} register={register} required />
                  </InputWrap>

                  <PrivasyWrapper spacing>
                    <Checkbox checked={checked} onChange={() => setChecked(!checked)}>
                      I agree with{" "}
                      <PrivacyPolicy target="_blank" href={`/terms-of-service`}>
                        Terms of Service Agreement
                      </PrivacyPolicy>{" "}
                      and{" "}
                      <PrivacyPolicy target="_blank" href={`/privacy-policy`}>
                        Privacy Policy
                      </PrivacyPolicy>
                    </Checkbox>
                  </PrivasyWrapper>
                  <BtnsBottom>
                    {isRenderPrev && (
                      <ItemBtn>
                        <Button
                          iconLeft="arrow_left"
                          stylType="secondary"
                          onClick={toRegistrationPage}
                          text="Previous"
                        />
                      </ItemBtn>
                    )}

                    <ItemBtn>
                      <Button disabled={!checked} stylType="primary" color={colors.RED} text="Sign Up" />
                    </ItemBtn>
                  </BtnsBottom>
                </FormInner>
              </form>
            )}
          </FormContainer>
        </GridColumn>
      </Container>
      {isBlur && <OverlayMessage isBlur={isBlur} />}
    </>
  );
};

export default FoodieForm;
